import { Popconfirm, Tag } from 'antd';
import i18next from 'i18next';
import React from 'react';
import { FaEye, FaPencilAlt, FaRegTrashAlt } from 'react-icons/fa';
import Button from '~/components/Button';
import Can from '~/components/Can';
import Cannot from '~/components/Cannot';
import { TableActions } from '~/components/Table';
import IsMobile from '~/services/mobileCheck';
import { formatPrice } from '~/Utils/format';

const months = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];

const capitalizeFirstLetter = (string) => {
  return string ? string[0].toUpperCase() + string.slice(1) : string;
};

export const financialExpensesColumns = (handleEdit, handleDelete) => {
  const isMobile = IsMobile();

  if (isMobile) {
    return [
      {
        dataIndex: 'summary',
        key: 'summary',
        render: (_, record) => (
          <div>
            <strong>{i18next.t('screens:default.name')}:</strong> {record.name}
            <br />
            <strong>{i18next.t('screens:expenses.type')}:</strong>{' '}
            {record.expense_type === 0 ? (
              <Tag color="blue">FIXA</Tag>
            ) : record.expense_type === 1 ? (
              <Tag color="cyan">FIXA / VARIÁVEL</Tag>
            ) : (
              <Tag color="green">VARIÁVEL</Tag>
            )}
            <br />
            <TableActions align="center" justify="flex" isMobile={isMobile}>
              <Can permission="@expenses/edit">
                <Button size="small" title="Editar" onClick={() => handleEdit(record)}>
                  <FaPencilAlt />
                </Button>
              </Can>
              <Button style={{ margin: 'auto' }} size="small" title="Visualizar" onClick={() => handleEdit(record)}>
                <FaEye />
              </Button>
              <Can permission="@xpenses/delete">
                <Popconfirm
                  title={i18next.t('messages:confirmDelete')}
                  okText={i18next.t('messages:yes')}
                  onConfirm={() => handleDelete(record.id)}
                  cancelText={i18next.t('messages:no')}
                >
                  <Button size="small" title="Excluir">
                    <FaRegTrashAlt />
                  </Button>
                </Popconfirm>
              </Can>
            </TableActions>
          </div>
        ),
      },
    ];
  }

  return [
    {
      title: i18next.t('screens:default.name'),
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: i18next.t('screens:expenses.type'),
      dataIndex: 'expense_type',
      key: 'expense_type',
      width: '300px',
      render: (_, record) => {
        if (record.expense_type === 0) {
          return <Tag color="blue">FIXA</Tag>;
        }
        if (record.expense_type === 1) {
          return <Tag color="cyan">FIXA / VARIÁVEL</Tag>;
        }
        return <Tag color="green">VARIÁVEL</Tag>;
      },
    },
    {
      title: i18next.t('screens:default.actions'),
      dataIndex: 'actions',
      key: 'actions',
      width: '140px',
      align: 'center',
      render: (_, record) => (
        <TableActions align="center" justify="center">
          <Button size="small" title="Visualizar" onClick={() => handleEdit(record, true)}>
            <FaEye />
          </Button>
          <Can permission="@expenses/edit">
            <Button size="small" title="Editar" onClick={() => handleEdit(record)}>
              <FaPencilAlt />
            </Button>
          </Can>
          <Can permission="@xpenses/delete">
            <Popconfirm
              title={i18next.t('messages:confirmDelete')}
              okText={i18next.t('messages:yes')}
              onConfirm={() => handleDelete(record.id)}
              cancelText={i18next.t('messages:no')}
            >
              <Button size="small" title="Excluir">
                <FaRegTrashAlt />
              </Button>
            </Popconfirm>
          </Can>
        </TableActions>
      ),
    },
  ];
};

export const registerTableColumns = (handleEdit) => {
  return [
    {
      title: i18next.t('screens:itemExpenses.name'),
      dataIndex: 'name',
      key: 'name',
    },
    ...months.map((month) => ({
      title: i18next.t(`screens:itemExpenses.${month}`),
      dataIndex: month,
      key: month,
      render: (_, record) => record?.montly_expenses?.[capitalizeFirstLetter(month)]?.total ?? '0,00',
    })),
    {
      title: i18next.t('screens:itemExpenses.total'),
      dataIndex: 'total',
      key: 'total',
      render: (_, record) => record?.montly_expenses?.total ?? '0,00',
    },
    {
      title: i18next.t('screens:default.actions'),
      dataIndex: 'actions',
      key: 'actions',
      width: '80px',
      align: 'center',
      render: (_, record) => (
        <TableActions align="center" justify="center">
          <Can permission="@registerExpenses/edit">
            <Button size="small" title="Editar" onClick={() => handleEdit(record.id)}>
              <FaPencilAlt />
            </Button>
          </Can>
          <Cannot permission="@registerExpenses/edit">
            <Button size="small" title="Visualizar" onClick={() => handleEdit(record.id)}>
              <FaEye />
            </Button>
          </Cannot>
        </TableActions>
      ),
    },
  ];
};

export const reportTableColumns = () => {
  return [
    {
      title: i18next.t('Tipo'),
      dataIndex: 'name',
      key: 'name',
    },
    ...months.map((month) => ({
      title: i18next.t(`screens:itemExpenses.${month}`),
      dataIndex: month,
      key: month,
      render: (text, _) => formatPrice(text),
    })),
    {
      title: i18next.t('screens:itemExpenses.total'),
      dataIndex: 'total',
      key: 'total',
      render: (text, _) => formatPrice(text),
    },
  ];
};
